import { DataModel } from '#data-models.ts';

import * as viewsObject from '#schema/generated/ipso/views.ts';

const excludedDataModels: string[] = [DataModel.IpsoSolution.externalId];

// No type assertion on the entries: the generated view types relate to
// themselves by identity, which is cheap. Asserting them to `any` or to a
// small structural surface forces the checker to elaborate the enormous
// generated namespace structurally, exhausting its relation budget and
// silently degrading contextual typing (implicit-any) in files checked
// later in the same program.
const filteredViews = Object.entries(viewsObject).filter(
  ([, value]) => !excludedDataModels.includes(value.dataModel.externalId),
);

export const views = Object.fromEntries(filteredViews) as typeof viewsObject;
